// prevent iOS open in safari
$("a").click(function (event) {
  event.preventDefault();
  var href = $(this).attr("href");
  if (href) {
    setTimeout(function () {
      $("div.loading").css("visibility", "visible");
    }, 100);
    window.location = href;
  }
});

function jump(h) {
  var ele = $(h);
  if (!ele) return;

  // we are scrolling divs, so we need to calculate the relative distance)
  var top = Math.abs($(".frame .top").offset().top - $(h).offset().top) - 20;
  $(".frame")[0].scrollTop = top;
}

String.prototype.capitalize = function () {
  return this.replace(/(^|\s)([a-z])/g, function (m, p1, p2) {
    return p1 + p2.toUpperCase();
  });
};

var signaturePad;
var state = {
  firstname: "",
  lastname: "",
  email: "",
  location: kioskLocation.capitalize(),
  newrooms: {},
  how: [],
  corporate: {},
  escaping_with: "",
  opted_into_email: null,
  zip: "",
  address: "",
  phone: "",
  kids: 0,
  agree: 0,
  language: "English",
};

var customerRequiresName = true;
var processing = false;

document.addEventListener("DOMContentLoaded", function () {
  var loadedEmail = "";
  var canvas = document.querySelector("canvas");
  signaturePad = new SignaturePad(canvas);

  function loadCustomer(email) {
    // don't load the email more than once
    if (email === loadedEmail) {
      return;
    }
    loadedEmail = email;

    $.ajax({
      url: "/api/kiosk/get",
      dataType: "json",
      contentType: "application/json",
      method: "post",
      data: JSON.stringify({ email: email }),
    })
      .done(function (response) {
        if (response.lookupFailed) {
          error(text.error_connection);
          return;
        }

        customerRequiresName = response.requireName !== false;

        if (response.requireName === false) {
          $("#scroll-name").hide();
        } else {
          $("#scroll-name").show();
        }

        if (response.requireBirthdate === false) {
          $(".question-birthdate").hide();
        } else {
          $(".question-birthdate").show();
        }

        if (response.requirePhoneZip === false) {
          $(".question-zip").hide();
        } else {
          $(".question-zip").show();
        }

        if (response.requireCompany === false) {
          $(".question-company").hide();
        } else {
          $(".question-company").show();
        }

        $(".kiosk-muted").removeClass("muted");
      })
      .fail(function (err) {
        error(text.error_connection);
        return;
      });
  }

  $("#clear").on("click", function (e) {
    signaturePad.clear();
  });

  $("#email").on("change", function (e) {
    var email = $(this).val().trim().toLowerCase();
    if (email === "guest") {
      $(".kiosk-muted").removeClass("muted");
    } else {
      loadCustomer(email);
    }
  });

  $("#email").on("keyup", function (e) {
    var email = $(this).val().trim().toLowerCase();
    if (/(com|org|net|edu|gov|ca)$/.test(email)) {
      loadCustomer(email);
    } else if (email === "guest") {
      $(".kiosk-muted").removeClass("muted");
    }
  });

  $("#company").on("tap", ".btn-value", function () {
    var $btn = $(this);
    var value = $btn.attr("data-value") || $btn.text();
    $("#company .btn-value").removeClass("btn-on");
    if ($btn.hasClass("btn-on")) {
      $(this).removeClass("btn-on");
      state.company = "";
    } else {
      $(this).addClass("btn-on");
      state.company = value;
    }
  });

  $("#escaping_with").on("tap", ".btn-value", function () {
    var $btn = $(this);
    var value = $btn.attr("data-value") || $btn.text();
    $("#escaping_with .btn-value").removeClass("btn-on");
    if ($btn.hasClass("btn-on")) {
      $(this).removeClass("btn-on");
      state.escaping_with = "";
    } else {
      $(this).addClass("btn-on");
      state.escaping_with = value;
    }
  });

  $("#vip").on("tap", ".btn-value", function () {
    var $btn = $(this);
    var value = $btn.attr("data-value") || $btn.text();
    if ($btn.hasClass("btn-on")) {
      $(this).removeClass("btn-on");
      state.vip = false;
    } else {
      $(this).addClass("btn-on");
      state.vip = true;
    }
  });

  $("#kids").on("tap", ".btn-value", function () {
    var $btn = $(this);
    var value = $btn.attr("data-value") || $btn.text();
    $("#kids .btn-value").removeClass("btn-on");
    if ($btn.hasClass("btn-on")) {
      $(this).removeClass("btn-on");
      state.kids = value;
    } else {
      $(this).addClass("btn-on");
      state.kids = value;
    }
  });

  $("#new-rooms").on("tap", ".btn-value", function () {
    var $btn = $(this);
    var value = $btn.attr("data-venue") + ":" + $btn.attr("data-event");
    if ($btn.hasClass("btn-on")) {
      $(this).removeClass("btn-on");
      state.newrooms[value] = 0;
    } else {
      $(this).addClass("btn-on");
      state.newrooms[value] = 1;
    }
  });

  $("#agree").on("tap", function () {
    var $btn = $(this);
    var value = $btn.text();
    if ($btn.hasClass("btn-on")) {
      $(this).removeClass("btn-on");
      state.agree = 0;
    } else {
      $(this).addClass("btn-on");
      state.agree = 1;
    }
  });

  $("#day").on("keyup", function (e) {
    var $input = $(this);
    var value = $input.val();
    if (/[0-9][0-9]/.test(value) && value.length == 2) {
      $("#month").focus();
    }
  });

  $("#month").on("keyup", function (e) {
    var $input = $(this);
    var value = $input.val();
    if (/[0-9][0-9]/.test(value) && value.length == 2) {
      $("#year").focus();
    }
  });

  $("#done").on("tap", function () {
    // prevent double submit
    if (processing === true) {
      return;
    }
    processing = true;

    var data = $.extend(true, {}, state);
    data.firstname = $("#firstname").val().trim();
    data.lastname = $("#lastname").val().trim();
    data.email = $("#email").val().trim().toLowerCase();
    data.zip = $("#zip").length > 0 ? $("#zip").val().trim() : "";
    data.phone = $("#phone").length > 0 ? $("#phone").val().trim() : "";
    data.address = $("#address").length > 0 ? $("#address").val().trim() : "";
    data.language = $("#language").val();
    var year = $("#year").val().trim();
    var month = $("#month").val().trim();
    var day = $("#day").val().trim();
    if (day.length === 1) {
      day = "0" + day;
    }
    if (month.length === 1) {
      month = "0" + month;
    }
    if (year.length === 2) {
      year = "00" + year;
    }
    data.birthdate = [year, month, day].join("");

    // validate
    if (customerRequiresName && (!data.firstname || !data.lastname)) {
      processing = false;
      error(text.error_fullname);
      jump("#scroll-name");
      return;
    }

    if (!data.email) {
      processing = false;
      error(text.error_email);
      jump("#scroll-email");
      return;
    } else if (data.email.trim() === "guest") {
      data.email = "";
    }

    if ($("#address").length > 0) {
      if (!data.address || !data.phone) {
        processing = false;
        error("An address and phone number is required for contact tracing.");
        jump("#scroll-address");
        return;
      }
    }

    var newrooms = [];
    if (multiRoom) {
      for (var room in data.newrooms) {
        if (data.newrooms[room]) {
          newrooms.push(room);
        }
      }
    } else if (locationRooms.length > 0) {
      newrooms = [locationRooms[0]];
    }

    if (newrooms.length === 0) {
      processing = false;
      error(text.error_rooms);
      jump("#scroll-rooms");
      return;
    }

    if (!data.escaping_with) {
      processing = false;
      error(text.error_escaping_with);
      jump("#scroll-escaping-with");
      return;
    }

    if (signaturePad.isEmpty()) {
      processing = false;
      error(text.error_signature);
      return;
    }

    data.signature = signaturePad.toDataURL();
    data.newrooms = newrooms;

    startLoading();
    $.ajax({
      url: "/api/kiosk/send",
      dataType: "json",
      contentType: "application/json",
      method: "post",
      data: JSON.stringify(data),
    })
      .done(function (response) {
        stopLoading();
        processing = false;
        if (window.location.pathname.indexOf("/client_waiver") > -1) {
          waiver_thankyou({ tapToReload: true });
          if (ENABLE_ANALYTICS) {
            gtag("event", "sent", { send_to: "G-9BF9PSVTG2", event_category: "waiver", event_label: "online" });
          }
        } else if (window.location.pathname.indexOf("/waiver") > -1 && window.location.pathname.indexOf("/kiosk") === -1) {
          waiver_thankyou({ tapToReload: true });
          if (ENABLE_ANALYTICS) {
            gtag("event", "sent", { send_to: "G-9BF9PSVTG2", event_category: "waiver", event_label: "kiosk" });
          }
        } else {
          waiver_thankyou();
          if (ENABLE_ANALYTICS) {
            gtag("event", "sent", { send_to: "G-9BF9PSVTG2", event_category: "waiver", event_label: "kiosk" });
          }
          setTimeout(function () {
            window.location = kioskPath;
          }, 1000);
        }
      })
      .fail(function (err) {
        stopLoading();
        processing = false;
        error(text.error_connection);
        return;
      });
  });
});

function waiver_thankyou(options) {
  options = options || {};

  var $thankyou = $("div.thankyou");
  $thankyou.css("visibility", "visible");
  $thankyou.css("background-color", "rgba(6, 135, 22, 0.96)");
  $thankyou.find("> div").css("background-color", "initial");
  $thankyou
    .find("> div > span")
    .css("color", "white")
    .html("THANK YOU<br/>" + $("#firstname").val());

  // also scroll the page and inner kiosk frame to the top so the overlay
  // is visible no matter where the user was on the form
  window.scrollTo(0, 0);
  if ($(".frame").length) {
    $(".frame")[0].scrollTop = 0;
  }

  // for non-kiosk waivers (no auto-redirect) let the user tap the green
  // panel to reload the form for the next person
  if (options.tapToReload) {
    $thankyou.css({ "pointer-events": "auto", cursor: "pointer" });
    $thankyou.off("click.waiverReload tap.waiverReload").on("click.waiverReload tap.waiverReload", function () {
      window.location.reload();
    });
  }
}
